import WOW from 'wow.js';

document.addEventListener('DOMContentLoaded', (event) => {
    var scrollCheck = false;

    var fx = function fx() {
        $('.start-number').each(function (i, el) {
            var data = parseFloat(this.dataset.n); // Permite casas decimais
            var props = {
                from: {
                    count: 0,
                },
                to: {
                    count: data,
                },
            };

            $(props.from).animate(props.to, {
                duration: 3000 * 1,
                step: function (now, fx) {
                    const roundedNumber = Math.floor(now);
                    const formattedNumber = roundedNumber.toLocaleString('pt-BR');
                    $(el).text(`+ ${formattedNumber}`);
                },
                complete: function () {
                    const formattedNumber = data.toLocaleString('pt-BR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                    });
                    $(el).text(`+ ${formattedNumber}`);
                    if (el.dataset.sym !== undefined) {
                        el.textContent = el.textContent.concat(el.dataset.sym);
                    }
                },
            });
        });
    };

    var reset = function reset() {
        var section_counter = $('.animated-numbers').offset();
        if (!section_counter) {
            return;
        }
        if ($(this).scrollTop() > section_counter.top - 500 && scrollCheck == false) {
            scrollCheck = true;
            fx();
        }
    };

    $(window).on('scroll', reset);

    if ($('.wow').length) {
        var wow = new WOW({
            boxClass: 'wow', // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            mobile: true, // trigger animations on mobile devices (default is true)
            live: true, // act on asynchronously loaded content (default is true)
        });
        wow.init();
    }
});
